define 'controller/SimpleDataLayerController', ['jquery'], ($) ->
  class SimpleDataLayerController

    constructor: (@$el) ->
      @$self = @$el
      @_init()

    _init: ->
      try
        dataLayer.push(JSON.parse(decodeURIComponent(escape(atob(@$self.data('datalayerevent'))))))
      catch e
        try
          dataLayer.push(JSON.parse(atob(@$self.data('datalayerevent'))))
        catch e
